import Cookies from 'universal-cookie'
import { isCordova } from 'env.js'
import axios from 'axios'

window.hasslCookies = new Cookies()
window.tokenData = null

export const doToken = (action, valueString = null, callback) => {
    let response = null

    const value = JSON.stringify(valueString)

    if (action == 'get' && window.tokenData) {
        const value = window.tokenData

        return callback(processToken(value))
    }

    if (isCordova) {
        switch (action) {
            case 'get':
                window.NativeStorage.getItem('token', returnedValue => {
                    returnedValue = processToken(returnedValue)

                    callback(returnedValue)
                }, _ => {
                    callback(null)
                })
                break
            case 'set':
                window.tokenData = value

                window.NativeStorage.setItem('token', value)

                let jwtToken = null

                if (typeof value == 'string') {
                    jwtToken = JSON.parse(value).token
                } else {
                    jwtToken = value.token
                }

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken
                break
            case 'remove':
                window.NativeStorage.remove('token')
                break
        }
    } else {
        // we'll prioritise sessionStorage, in case you're in 2 accounts across different tabs.
        const storage = window.localStorage
        const tempStorage = window.sessionStorage

        switch (action) {
            case 'get':
                if (tempStorage.getItem('token')) {
                    response = tempStorage.getItem('token')
                } else if (storage.getItem('token')) {
                    response = storage.getItem('token')
                } else {
                    response = window.hasslCookies.get('token')
                }

                response = processToken(response)

                callback(response)
                break
            case 'set':
                // We're covering a lot of bases here.
                window.tokenData = value
                window.hasslCookies.set('token', value)
                tempStorage.setItem('token', value)
                storage.setItem('token', value)

                let jwtToken = null

                if (typeof value == 'string') {
                    jwtToken = JSON.parse(value).token
                } else {
                    jwtToken = value.token
                }

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken
                break
            case 'remove':
                storage.removeItem('token')
                break
        }
    }
}

const processToken = response => {
    if (response == '[object Object]' || !response) {
        response = {}
    } else if (!response.includes('userId')) {
        if (!response.includes("token")) {
            response = {
                token: response,
                userId: null
            }
        }else{
            response = {
                token: JSON.parse(response).token,
                userId: null
            }
        }
    } else {
        response = JSON.parse(response)
    }

    return response
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js